import * as d3 from "d3";
export default class IsochroneWheel {
  #svgId;
  #svgTimer: any;
  #data!: string[];
  #correspondingAngle: [number, number][];
  #pie: any;
  #color: any;
  #arcGenerator: any;

  constructor(id: number) {
    this.#svgId = "isochrone" + id;

    this.#data = [
      "5 Min",
      "10 Min",
      "15 Min",
      "20 Min",
      "25 Min",
      "30 Min",
      "35 Min",
      "40 Min",
      "45 Min",
      "50 Min",
      "55 Min",
      "60 Min",
    ];
    this.#correspondingAngle = [
      [4.660029172897338, 5.177810192108154],
      [5.177810192108154, 5.695591211318969],
      [5.695591211318969, 7],
      [0, 0.5177810192108154],
      [0.5177810192108154, 1.0355620384216308],
      [1.0355620384216308, 1.5533430576324462],
      [1.5533430576324462, 2.0711240768432615],
      [2.0711240768432615, 2.588905096054077],
      [2.588905096054077, 3.1066861152648924],
      [3.1066861152648924, 3.6244671344757078],
      [3.6244671344757078, 4.142248153686523],
      [4.142248153686523, 4.660029172897338],
    ];
    this.#color = d3
      .scaleOrdinal()
      .range([
        "#FEEACD",
        "#E7D5BA",
        "#D1C0A8",
        "#BBAC96",
        "#A59884",
        "#908473",
        "#7B7162",
        "#675F52",
        "#544D42",
        "#413B33",
        "#302B24",
        "#1F1C17",
      ]);
    this.#pie = d3
      .pie()
      .sort(null)
      .value(function (d) {
        return 10;
      });
    this.#arcGenerator = d3.arc().innerRadius(72).outerRadius(120);
  }

  addWheel(x: number, y: number, angle: number) {
    var svg = d3.select("#" + this.#svgId).empty()
      ? d3.select("#isochroneWheelMenu").append("svg")
      : d3.select("#" + this.#svgId);
    var screenX = window.innerWidth * x;
    var screenY = window.innerHeight * y;
    var angle = angle;

    svg
      .attr("id", this.#svgId)
      // @ts-ignore
      .attr("width", window.innerWidth)
      .attr("height", window.innerHeight);

    this.removeAfterDelay();

    var g = svg
      // @ts-ignore
      .selectAll("arc")
      //   @ts-ignore
      .data(this.#pie(this.#data))
      // @ts-ignore
      .enter()
      .append("g")
      .attr("transform", "translate(" + screenX + "," + screenY + ")");

    g.append("path")
      .attr("d", this.#arcGenerator)
      .attr("fill", (d: any) => this.#color(d.data))
      .attr("stroke", "black")
      .style("stroke-width", "2px")
      .style("opacity", 0.7)
      .attr("class", (d: any, i: number) => {
        if (
          angle >= this.#correspondingAngle[i][0] &&
          angle <= this.#correspondingAngle[i][1]
        ) {
          return "highlight";
        } else {
          return "";
        }
      });

    svg
      .append("line")
      .attr("id", this.#svgId + "line")
      .attr("x1", screenX + 73 * Math.cos(angle))
      .attr("y1", screenY + 73 * Math.sin(angle))
      .attr("x2", screenX + 119 * Math.cos(angle))
      .attr("y2", screenY + 119 * Math.sin(angle))
      .attr("stroke-width", 3)
      .attr("stroke", "red")
      .style("opacity", 0.5);

    g.append("text")
      .attr(
        "transform",
        (d: any) => "translate(" + this.#arcGenerator.centroid(d) + ")"
      )
      .attr("text-anchor", "middle")
      .style("fill", (d: any, i: number) => (i >= 6 ? "#FFFFFF" : "black"))
      .text((d: any) => d.data);
  }

  updateWheel(x: number, y: number, angle: number) {
    var svg = d3.select("#" + this.#svgId);

    if (svg.empty()) {
      this.addWheel(x, y, angle);
      return;
    }

    var screenX = window.innerWidth * x;
    var screenY = window.innerHeight * y;

    this.removeAfterDelay();

    // Update the position of the arc groups
    svg
      .selectAll("g")
      .attr("transform", "translate(" + screenX + "," + screenY + ")");

    svg.selectAll("path").attr("class", (d, i) => {
      if (
        angle >= this.#correspondingAngle[i][0] &&
        angle <= this.#correspondingAngle[i][1]
      ) {
        return "highlight";
      } else {
        return "";
      }
    });

    // Update the position of the line indicator
    svg
      .select("#" + this.#svgId + "line")
      .attr("x1", screenX + 73 * Math.cos(angle))
      .attr("y1", screenY + 73 * Math.sin(angle))
      .attr("x2", screenX + 119 * Math.cos(angle))
      .attr("y2", screenY + 119 * Math.sin(angle));

    // Update the position of the text elements
    svg
      .selectAll("text")
      .attr(
        "transform",
        (d) => "translate(" + this.#arcGenerator.centroid(d) + ")"
      );
  }

  removeWheel() {
    d3.select("#" + this.#svgId).remove();
  }

  removeAfterDelay() {
    clearTimeout(this.#svgTimer);

    this.#svgTimer = setTimeout(() => {
      d3.select("#" + this.#svgId).remove();
    }, 3500);
  }
}
